export default __webpack_public_path__ + "static/media/20.77e0d267.webp";